export default "__VITE_ASSET__qX_D_qbo__"